<template>
    <div>
        <div
            class="video-placeholder w-full md:w-1/3 lg:w-1/4 p-2"
            v-for="video in videos"
            :key="video.id"
        >
            <img
                class="object-contain"
                :id="video.id"
                :src="video.image"
                title="video.caption"
                alt="video.caption"
                :type="video.type"
                :key="video.id"
                :data="video.id"
                @click="openVideo"
            />
            <i
                class="video-play far fa-play-circle"
                @click="openVideo"
                :data="video.id"
                :type="video.type"
            ></i>
        </div>
    </div>
</template>
<script>
export default {
    props: ["videos"],
    methods: {
        openVideo(e) {
            this.$emit("open-video-modal", {
                data: e.target.getAttribute("data"),
                type: e.target.getAttribute("type")
            });
        }
    }
};
</script>
